<img class="col-lg-7 col-md-7 col-xs-12 no-padding hide-desktop mobile-banner"
    src="assets/img/Health_Insurance_assets_Mobile_banner_Mobile.png" alt="banner image" *ngIf="!bflJourney">
<div class="banner-text hide-desktop" *ngIf="!bflJourney">
    <p>Stay protected against rising medical costs, with Health Insurance</p>
    <ul class="list-inline">
        <li class="no-padding-right">Get it instantly,</li>
        <li class="no-padding-right">through a quick & hassle-free process</li>
        <li class="no-padding-right" *ngIf="!bflJourney">, only on Finserv MARKETS!</li>
    </ul>
</div>
<img class="col-lg-7 col-md-7 col-xs-12 no-padding hide-desktop getgoing-banner-img-bfl"
    src="assets/img/MedicalImage.png" alt="banner image" *ngIf="bflJourney">

<div class="col-lg-7 col-md-7 col-xs-12 getgoing-banner no-padding hide-mobile">
    <div class="banner-text-fullscreen">
        <h4 *ngIf="!bflJourney"> <span>Benefits</span> of buying Health Insurance</h4>
        <h6 *ngIf="!bflJourney" class="dark-theme-gray">Bajaj offers one of the best health Insurance policy for the
            Individual & Family. Covers Pandemic Treatments, Pre/Post Hospitalization expenses, Maternity expenses &
            more.</h6>
        <h6 *ngIf="bflJourney" class="dark-theme-gray">Bajaj Finance Limited offers optimized health insurance plans for
            both individuals and their families</h6>
    </div>
    <div class="col-lg-12 col-md-12 top-spc-9">
        <img class="col-lg-6 col-md-6 getgoing-banner-img" src="assets/img/png/getgoing.png" alt="Banner image"
            *ngIf="!bflJourney">
        <img class="col-lg-6 col-md-6 getgoing-banner-img-bfl" src="assets/img/MedicalImage.png" alt="Banner image"
            *ngIf="bflJourney">
        <div class="col-lg-5 col-md-5 ">
            <ul class="list-inline">
                <li class="pointer">
                    <div class="col-md-2 col-lg-2 numbering">
                        <p class="count-num border-circle center">1</p>
                    </div>
                    <div class="col-md-10 col-lg-10 no-pad" *ngIf="!bflJourney">
                        <h6>Tax Benefits</h6>
                        <div class="dark-theme-gray">For salaried individuals who are having health insurance plans can
                            claim</div>
                    </div>
                    <div class="col-md-10 col-lg-10 no-pad" *ngIf="bflJourney">
                        <h6>Covers pandemic like COVID-19</h6>
                        <div class="dark-theme-gray">Our health insurance plans offer coverage for diseases like
                            COVID-19 so that you don't need to invest in separate policy for the same.</div>
                    </div>
                </li>
                <li class="pointer">
                    <div class="col-md-2 col-lg-2 numbering">
                        <p class="count-num border-circle center">2</p>
                    </div>
                    <div class="col-md-10 col-lg-10 no-pad" *ngIf="!bflJourney">
                        <h6>Cashless Treatment</h6>
                        <div class="dark-theme-gray">For salaried individuals who are having health insurance plans can
                            claim</div>
                    </div>
                    <div class="col-md-10 col-lg-10 no-pad" *ngIf="bflJourney">
                        <h6>Cashless Treatment</h6>
                        <div class="dark-theme-gray">A wide pan India network of hospitals from our partners allows you
                            to get cashless treatment. </div>
                    </div>
                </li>
                <li class="pointer">
                    <div class="col-md-2 col-lg-2 numbering">
                        <p class="count-num border-circle center">3</p>
                    </div>
                    <div class="col-md-10 col-lg-10 no-pad" *ngIf="!bflJourney">
                        <h6>Free Health Checkups</h6>
                        <div class="dark-theme-gray">For salaried individuals who are having health insurance plans can
                            claim</div>
                    </div>
                    <div class="col-md-10 col-lg-10 no-pad" *ngIf="bflJourney">
                        <h6>Paperless Digital Process </h6>
                        <div class="dark-theme-gray">Our seamless digital buying process makes sure there is no tedious
                            paperwork</div>
                    </div>
                </li>
                <li class="pointer" *ngIf="bflJourney">
                    <div class="col-md-2 col-lg-2 numbering">
                        <p class="count-num border-circle center">4</p>
                    </div>
                    <div class="col-md-10 col-lg-10 no-pad">
                        <h6>Cumulative Bonus </h6>
                        <div class="dark-theme-gray">If you take good care of yourself, get rewarded with a yearly
                            cumulative bonus for claim-free years. </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</div>

<div class="col-lg-5 col-md-5 col-xs-12 no-padding">
    <ng-container>
        <section *ngIf="showLoader">
            <app-loader></app-loader>
        </section>
        <div class="otp-box">
            <ng-container *ngTemplateOutlet="otpBody"></ng-container>
        </div>
    </ng-container>
</div>

<ng-template #otpBody>
    <div class="drawer-info p-3 pt-4 pb-5">
        <div class="col opt-container">
            <div class="pl-1">
                <h4 class="text-bold mt-3 mb-4">OTP Verification</h4>
                <p class="mb-4 sub-txt">Enter 6 digit OTP sent to your mobile number +91 {{ mobileNumber }} </p>
            </div>
            <div class="otp-control">
                <form [formGroup]="healthOtpForm">
                    <div class="digit-group bot-spc-10 center m-t-2">
                        <input #digit1 formControlName="digit1" type="tel"
                            (keydown)="onKeydown($event, digit1, digit2)" aria-label="otp"
                            (input)="onOTPReceive(digit1,'input',digit2);FormValidators.onInputEntry($event, digit2)"
                            (keypress)="FormValidators.IsNumeric($event)" pattern="^[0-9]*$" maxlength="1"
                            (click)="onOTPReceive(digit1,'click');" (paste)="onPaste($event, digit1)"
                            (blur)="onOTPReceive(digit1,'blur');" (focus)="onOTPReceive(digit1,'focus');" />
                        <input #digit2 formControlName="digit2" type="tel" (keydown)="onKeydown($event, digit1, digit3)"
                            (input)="FormValidators.onInputEntry($event, digit3)"
                            (keypress)="FormValidators.IsNumeric($event)" pattern="^[0-9]*$" maxlength="1"
                            (paste)="onPaste($event)" />
                        <input #digit3 formControlName="digit3" type="tel" (keydown)="onKeydown($event, digit2, digit4)"
                            (input)="FormValidators.onInputEntry($event, digit4)"
                            (keypress)="FormValidators.IsNumeric($event)" pattern="^[0-9]*$" maxlength="1"
                            (paste)="onPaste($event)" />
                        <input #digit4 formControlName="digit4" type="tel" (keydown)="onKeydown($event, digit3, digit5)"
                            (input)="FormValidators.onInputEntry($event, digit5)"
                            (keypress)="FormValidators.IsNumeric($event)" pattern="^[0-9]*$" maxlength="1"
                            (paste)="onPaste($event)" />
                        <input #digit5 formControlName="digit5" type="tel" (keydown)="onKeydown($event, digit4, digit6)"
                            (input)="FormValidators.onInputEntry($event, digit6)"
                            (keypress)="FormValidators.IsNumeric($event)" pattern="^[0-9]*$" maxlength="1"
                            (paste)="onPaste($event)" />
                        <input #digit6 formControlName="digit6" type="tel" (keydown)="onKeydown($event, digit5, digit6)"
                            maxlength="1" (paste)="onPaste($event)" />
                    </div>
                </form>
                <div class="spc-btwn bot-spc-10">
                    <div class="col-md-3 d-md-flex mt-2" *ngIf="resendOTPCount < 5">
                        <span>
                            <span id="timer">00:60</span>
                        </span>
                    </div>
                    <a class="resend-mob-otp-link mb-1" (click)="resendOTP()" href="javascript:void(0);"
                        [ngClass]="{'grey-link':isTimerStarted|| mobileOtpTrails >= 5}">Resend OTP?</a>
                </div>

                <div class="row bot-spc-10" *ngIf="ServiceOTPError || wrongOtpMsg || (resendOTPCount >= 5)">
                    <div class="col-xs-12 center mb-1">
                        <span class="text-danger fontStyle"
                            *ngIf="ServiceOTPError && resendOTPCount < 5">{{ServiceOTPError}}</span>
                        <span class="text-danger fontStyle"
                            *ngIf="wrongOtpMsg && resendOTPCount < 5">{{wrongOtpMsg}}</span>

                        <span class="text-danger fontStyle" *ngIf="resendOTPCount >= 5">
                            You've exhausted all 5 attempts to enter the correct OTP.
                            Please resume your application after 10 minutes.
                        </span>
                    </div>
                </div>
                <!-- Submit Button  -->
                <div class="center">
                    <button class="btn btn-primary btnconfirm btn-single" type="submit"
                        (click)="validateOtp()">Proceed</button>
                </div>
                <!-- Submit Button -->

            </div>
        </div>
    </div>
</ng-template>